export default [
  {
    name: 'userInfoWorkbench',
    des: '获取用户信息',
    url: '/operate-api/bench/v1/userInfo',
    method: 'post',
  },
  {
    name: 'userInfoDeveloper', 
    des: '获取用户信息',
    url: '/open-api/system/v1/info',
    method: 'get',
  },
  {
    name: 'logout',
    des: '登出',
    url: '/auth-api/oauth2/logout',
    method: 'delete',
  }
]
